import {
    GET_AMAZON_PRODUCT_INFORMATION_REQUEST,
    GET_AMAZON_PRODUCT_INFORMATION_SUCCESS,
    GET_AMAZON_PRODUCT_INFORMATION_ERROR,
    GET_AMAZON_VIEW_PRODUCT_REQUEST,
    GET_AMAZON_VIEW_PRODUCT_SUCCESS,
    GET_AMAZON_VIEW_PRODUCT_ERROR,
    GET_AMAZON_PRODUCT_UPLOADER_REQUEST,
    GET_AMAZON_PRODUCT_UPLOADER_SUCCESS,
    GET_AMAZON_PRODUCT_UPLOADER_ERROR,
    GET_AMAZON_PRODUCT_UPLOADER_PANTS_DETAILS_REQUEST,
    GET_AMAZON_PRODUCT_UPLOADER_PANTS_DETAILS_SUCCESS,
    GET_AMAZON_PRODUCT_UPLOADER_PANTS_DETAILS_ERROR,
    GET_AMAZON_PRODUCT_UPLOADER_NEW_REQUEST,
    GET_AMAZON_PRODUCT_UPLOADER_NEW_SUCCESS,
    GET_AMAZON_PRODUCT_UPLOADER_NEW_ERROR,
    GET_AMAZON_PRODUCT_UPDATE_REQUEST,
    GET_AMAZON_PRODUCT_UPDATE_SUCCESS,
    GET_AMAZON_PRODUCT_UPDATE_ERROR,
    UPDATE_AMAZON_PRODUCT_UPDATE_REQUEST,
    UPDATE_AMAZON_PRODUCT_UPDATE_SUCCESS,
    UPDATE_AMAZON_PRODUCT_UPDATE_ERROR,
    GET_AMAZON_PRODUCT_UPDATE_NEW_REQUEST,
    GET_AMAZON_PRODUCT_UPDATE_NEW_SUCCESS,
    GET_AMAZON_PRODUCT_UPDATE_NEW_ERROR,
    UPDATE_AMAZON_PRODUCT_UPDATE_NEW_REQUEST,
    UPDATE_AMAZON_PRODUCT_UPDATE_NEW_SUCCESS,
    UPDATE_AMAZON_PRODUCT_UPDATE_NEW_ERROR,
    GET_SYNC_AMAZON_PRODUCT_REQUEST,
    GET_SYNC_AMAZON_PRODUCT_SUCCESS,
    GET_SYNC_AMAZON_PRODUCT_ERROR
} from "./types.js";
import { AMZBASEURL, BASEURL } from "../../constant/config.js";
import moment from "moment";

const axios = require("axios");
export const getAmazonProductInformation = (token, data) => (dispatch) => {
    dispatch({ type: GET_AMAZON_PRODUCT_INFORMATION_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/AmazonProductInformation`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            product_status_id: data.product_status,
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            season_id: data.season_id === "All" ? null : data.season_id,
            sesaon_year_id: data.new_season_year_id === "All" ? null : data.new_season_year_id,
            gender_category_id: data.gender_category_id === "All" ? null : data.gender_category_id,
            item_code: (data.sku === "" || data.sku === "All") ? null : data.sku,
            style_id: data.style_id === "All" ? null : data.style_id,
            wash_id: data.wash_id === "All" ? null : data.wash_id,
            fit_category_id: data.fit_id === "All" ? null : data.fit_id,
            fabric_id: data.fabric === "All" ? null : data.fabric,
            amazon_status: data.status,
            sort_on: null,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_AMAZON_PRODUCT_INFORMATION_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_AMAZON_PRODUCT_INFORMATION_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_AMAZON_PRODUCT_INFORMATION_ERROR,
                payload: error.response,
            });
        });
};


export const getAmazonViewProduct = (token, parentItemCode, Inseam) => (dispatch) => {
    dispatch({ type: GET_AMAZON_VIEW_PRODUCT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/AmazonProductDetails`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            parent_item_code: parentItemCode === undefined || parentItemCode === null || parentItemCode === "" ? null : parentItemCode,
            inseam: Inseam === undefined || Inseam === null || Inseam === "" ? null : Inseam,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_AMAZON_VIEW_PRODUCT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_AMAZON_VIEW_PRODUCT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_AMAZON_VIEW_PRODUCT_ERROR,
                payload: error.response,
            });
        });
};

export const getAmazonProductUploader = (token, data) => (dispatch) => {
    dispatch({ type: GET_AMAZON_PRODUCT_UPLOADER_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/AmazonProductUploaderReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            product_status_id: data.product_status,
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            gender_category_id: null,
            // item_code: (data.sku === "" || data.sku === "All") ? null : data.sku,
            style_id: data.style_id === "All" ? null : data.style_id,
            wash_id: data.wash_id === "All" ? null : data.wash_id,
            fit_category_id: data.fit_id === "All" ? null : data.fit_id,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_AMAZON_PRODUCT_UPLOADER_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_AMAZON_PRODUCT_UPLOADER_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_AMAZON_PRODUCT_UPLOADER_ERROR,
                payload: error.response,
            });
        });
};

export const getAmazonProductUploaderNew = (token, data) => (dispatch) => {
    dispatch({ type: GET_AMAZON_PRODUCT_UPLOADER_NEW_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/AmazonProductUploaderReportNew`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            product_status_id: data.product_status,
            gender_id: data.gender_id === "All" ? null : data.gender_id,
            gender_category_id: null,
            style_id: data.style_id === "All" ? null : data.style_id,
            // wash_id: data.wash_id === "All" ? null : data.wash_id.join(","),
            wash_id: (data?.wash_id?.includes("All") || data.wash_id?.includes(undefined)) ? null : data.wash_id.toString(),
            fit_category_id: data.fit_id === "All" ? null : data.fit_id,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_AMAZON_PRODUCT_UPLOADER_NEW_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_AMAZON_PRODUCT_UPLOADER_NEW_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_AMAZON_PRODUCT_UPLOADER_NEW_ERROR,
                payload: error.response,
            });
        });
};

export const getAmazonProductUploaderDetailsPants = (token, parentItemID, skuInseam) => (dispatch) => {
    dispatch({ type: GET_AMAZON_PRODUCT_UPLOADER_PANTS_DETAILS_REQUEST });
    const payload = {
        storeKey: "ww",
        parent_item_ids: Array.isArray(parentItemID) ? parentItemID : [parentItemID],
        child_item_ids: Array.isArray(skuInseam) ? skuInseam : [skuInseam]
    };

    console.log("payload", payload)
    return axios({
        method: "POST",
        url: `${AMZBASEURL}api/amazonProductTemplate`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token, 'X-API-Key': 'wxhnURvdjcDjG7CwqNEAe4C1X8Gna5Q4LHOPw' },
        data: payload,
    })
        .then((response) => {
            return dispatch({ type: GET_AMAZON_PRODUCT_UPLOADER_PANTS_DETAILS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_AMAZON_PRODUCT_UPLOADER_PANTS_DETAILS_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_AMAZON_PRODUCT_UPLOADER_PANTS_DETAILS_ERROR,
                payload: error.response,
            });
        });
};

export const getAmazonProductUpdate = (token, values) => (dispatch) => {
    dispatch({ type: GET_AMAZON_PRODUCT_UPDATE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/AmazonProductUpdateInfo`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            parent_item_code: (values.sku === "" || values.sku === "All") ? null : values.sku,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_AMAZON_PRODUCT_UPDATE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_AMAZON_PRODUCT_UPDATE_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_AMAZON_PRODUCT_UPDATE_ERROR,
                payload: error.response,
            });
        });
};


export const updateAmazonProductUpdate = (token, ParentItemID, values) => (dispatch) => {
    dispatch({ type: UPDATE_AMAZON_PRODUCT_UPDATE_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/AmazonProductUpdate/${ParentItemID}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { ...values }
    })
        .then((response) => {
            return dispatch({ type: UPDATE_AMAZON_PRODUCT_UPDATE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: UPDATE_AMAZON_PRODUCT_UPDATE_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: UPDATE_AMAZON_PRODUCT_UPDATE_ERROR,
                payload: error.response,
            });
        });
};

export const getAmazonProductUpdateNew = (token, values) => (dispatch) => {
    dispatch({ type: GET_AMAZON_PRODUCT_UPDATE_NEW_REQUEST });
    return axios({
        method: "POST",
        url: `${AMZBASEURL}api/products/listingAttributes`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token, 'X-API-Key': 'wxhnURvdjcDjG7CwqNEAe4C1X8Gna5Q4LHOPw' },
        data: {
            sku: (values.sku === "" || values.sku === "All") ? null : values.sku,
            storeKey: "ww"
        }
    })
        .then((response) => {
            return dispatch({ type: GET_AMAZON_PRODUCT_UPDATE_NEW_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_AMAZON_PRODUCT_UPDATE_NEW_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_AMAZON_PRODUCT_UPDATE_NEW_ERROR,
                payload: error.response,
            });
        });
};

export const updateAmazonProductUpdateNew = (token, values) => (dispatch) => {
    dispatch({ type: UPDATE_AMAZON_PRODUCT_UPDATE_NEW_REQUEST });
    return axios({
        method: "PATCH",
        url: `${AMZBASEURL}api/products/updateAmazonProduct`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token, 'X-API-Key': 'wxhnURvdjcDjG7CwqNEAe4C1X8Gna5Q4LHOPw' },
        data: { ...values }
    })
        .then((response) => {
            return dispatch({ type: UPDATE_AMAZON_PRODUCT_UPDATE_NEW_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: UPDATE_AMAZON_PRODUCT_UPDATE_NEW_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: UPDATE_AMAZON_PRODUCT_UPDATE_NEW_ERROR,
                payload: error.response,
            });
        });
};


export const getSYNCAmazonProduct = (token) => (dispatch) => {
    dispatch({ type: GET_SYNC_AMAZON_PRODUCT_REQUEST });
    return axios({
        method: "POST",
        url: `${AMZBASEURL}api/products/sync`,
        headers: { Accept: "application/json", Authorization: "Bearer " + token, 'X-API-Key': 'wxhnURvdjcDjG7CwqNEAe4C1X8Gna5Q4LHOPw' },
        data: { storeKey: "ww" }
    })
        .then((response) => {
            return dispatch({ type: GET_SYNC_AMAZON_PRODUCT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_SYNC_AMAZON_PRODUCT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_SYNC_AMAZON_PRODUCT_ERROR,
                payload: error.response,
            });
        });
};